import appState from '../util/appState';

const user = {
  init() {
    // JavaScript to be fired on the user pages

    // Show password toggle for Reset Password
    document.querySelectorAll('a.show-password').forEach(field => {
      field.addEventListener('click', e => {
        e.preventDefault();
        document.querySelectorAll('input.password').forEach(pwd => {
          let newType = pwd.type == 'password' ? 'text' : 'password';
          pwd.type = newType;
        });
      });
    });

  },

  finalize() {
    // JavaScript to be fired on the user page, after the init JS
  },
};

export default user
